import { createContext, useCallback, useContext, useMemo, useState } from 'react'

// Global "which SideShift-style popup is open, and with what pre-filled
// state" store. One modal shell (see components/FormModal.jsx) is mounted
// once at the app root and reads from here — so any button anywhere
// (Navbar, Hero, a pricing card, a campaign page CTA) can pop the same
// flow open without needing to know where the modal actually lives in the
// tree, and without scrolling the page at all.
//
// kind is one of: null | 'inquiry' | 'intake' | 'partner' | 'freeBuild'
const FormModalContext = createContext(null)

export function FormModalProvider({ children }) {
  const [kind, setKind] = useState(null)
  const [props, setProps] = useState({})

  const close = useCallback(() => setKind(null), [])

  const openInquiry = useCallback((opts = {}) => {
    setProps(opts)
    setKind('inquiry')
  }, [])

  const openIntake = useCallback(() => {
    setProps({})
    setKind('intake')
  }, [])

  const openPartnerApply = useCallback((opts = {}) => {
    setProps(opts)
    setKind('partner')
  }, [])

  const openFreeBuild = useCallback(() => {
    setProps({})
    setKind('freeBuild')
  }, [])

  const value = useMemo(
    () => ({ kind, props, close, openInquiry, openIntake, openPartnerApply, openFreeBuild }),
    [kind, props, close, openInquiry, openIntake, openPartnerApply, openFreeBuild]
  )

  return <FormModalContext.Provider value={value}>{children}</FormModalContext.Provider>
}

export function useFormModal() {
  const ctx = useContext(FormModalContext)
  if (!ctx) throw new Error('useFormModal must be used within a FormModalProvider')
  return ctx
}
